import { connect } from 'react-redux';
import React, { Component } from 'react';

import ApiList from './ApiList';

import {Drawer as LeftNav, Menu, MenuItem} from 'material-ui';

class SideBar extends Component {
  render() {
    return (
      <LeftNav style={{left: 0, overflowX: 'hidden'}} width={500} open={this.props.open} docked={false} onRequestChange={this.props.stateChanged}>
        <div style={{height: 65}}/>
        <ApiList/>
      </LeftNav>
    );
  }
}

export default connect(
  state => (
    {
      open: state.get('sidebar').get('visible')
    }
  ),
  dispatch => (
    {
      stateChanged(action) {
        if (!action) {
          dispatch({type: 'HIDE_NAV'});
        }
      }
    }
  )
)(SideBar);
